// -------------------------------------------------------------
// REALTIME VISITOR & SESSION TRACKER FOR SATALA DERMATECH ESSENTIAL
// -------------------------------------------------------------

const getCookie = (name) => {
  try {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  } catch (e) {
    return null;
  }
};

const setCookie = (name, value, days = 365) => {
  try {
    const d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()};SameSite=Lax`;
  } catch (e) {}
};

export const trackCurrentVisitor = async (pageName, userSession = null) => {
  try {
    const ua = navigator.userAgent;
    let device = 'Desktop PC';
    if (/iPhone/i.test(ua)) device = 'iPhone (iOS)';
    else if (/Android/i.test(ua)) device = 'Android Mobile';
    else if (/iPad/i.test(ua)) device = 'iPad (iOS)';
    else if (/Macintosh/i.test(ua)) device = 'MacBook (macOS)';

    let browser = 'Chrome';
    if (/Safari/i.test(ua) && !/Chrome/i.test(ua)) browser = 'Safari';
    else if (/Edg/i.test(ua)) browser = 'Edge';

    const path = window.location.pathname.toLowerCase();
    const isBackend = path.includes('/digitalmarketing') || path.includes('/office');

    let category = 'VISITOR_ANONYMOUS'; // Default
    if (isBackend) {
      category = 'INTERNAL_ADMIN';
    } else if (userSession && userSession.id) {
      category = 'CLIENT_VERIFIED';
    }

    // Universal Double-Layer Persistent Token (LocalStorage + 1-Year Cookie)
    // Applies to ALL routes: Public, Client Portal, and Internal Backend
    let deviceId = localStorage.getItem('satala_device_id') || getCookie('satala_device_id');
    if (!deviceId) {
      deviceId = `dev_${Date.now()}_${Math.floor(Math.random() * 8999 + 1000)}`;
    }
    try { localStorage.setItem('satala_device_id', deviceId); } catch(e){}
    setCookie('satala_device_id', deviceId, 365);

    // Single consistent Cookie-bound ID for ALL users (including Backend Admin)
    const userId = userSession?.id || (category === 'INTERNAL_ADMIN' ? `admin_${deviceId}` : deviceId);

    const name = category === 'INTERNAL_ADMIN' 
      ? (userSession?.name || 'Fadli (Marketing Team)') 
      : category === 'CLIENT_VERIFIED'
      ? (userSession?.name || 'Client Terverifikasi')
      : `Visitor ${device.split(' ')[0]} #${deviceId.slice(-4)}`;

    const urlParams = new URLSearchParams(window.location.search);
    const currentUtm = (urlParams.get('utm_source') || urlParams.get('source') || '').toLowerCase();
    
    // First-Touch UTM Campaign Memory in Cookie (365 Days)
    let savedUtm = getCookie('satala_first_touch_utm');
    if (currentUtm) {
      savedUtm = currentUtm;
      setCookie('satala_first_touch_utm', currentUtm, 365);
    }

    let sourceLabel = category === 'INTERNAL_ADMIN' ? 'Internal Backend' : category === 'CLIENT_VERIFIED' ? 'Client Login (Public)' : 'Direct Organik';
    const activeUtm = (currentUtm || savedUtm || '').toLowerCase();
    if (activeUtm.includes('meta') || activeUtm.includes('facebook') || activeUtm.includes('instagram') || urlParams.has('fbclid')) sourceLabel = 'Meta Ads';
    else if (activeUtm.includes('google') || urlParams.has('gclid')) sourceLabel = 'Google Ads';
    else if (activeUtm.includes('tiktok') || urlParams.has('ttclid')) sourceLabel = 'TikTok Ads';

    const payload = {
      id: userId,
      deviceId,
      name,
      email: category === 'INTERNAL_ADMIN' ? (userSession?.email || 'fadli@satala.co.id') : category === 'CLIENT_VERIFIED' ? (userSession?.email || 'client@satala.co.id') : '-',
      category,
      device: `${device} • ${browser}`,
      city: 'Indonesia',
      page: pageName || window.location.pathname,
      source: sourceLabel,
      lastActive: Date.now(),
      status: 'Online Sekarang'
    };

    // Save to local storage for local fallback
    try {
      const saved = localStorage.getItem('satala_realtime_visitors');
      let visitors = saved ? JSON.parse(saved) : [];
      const fiveMinsAgo = Date.now() - 5 * 60 * 1000;
      // Deduplicate by userId or email or deviceId
      visitors = visitors.filter(v => v.lastActive > fiveMinsAgo && v.id !== userId && v.deviceId !== deviceId && (payload.email === '-' || v.email !== payload.email));
      visitors.unshift(payload);
      localStorage.setItem('satala_realtime_visitors', JSON.stringify(visitors));
    } catch(e){}

    // Broadcast server ping
    try {
      await fetch('/api/live-visitors.php?action=ping', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    } catch(e){}

    window.dispatchEvent(new Event('satala_visitors_changed'));
  } catch (e) {
    console.error('Error tracking visitor:', e);
  }
};

export const getRealtimeVisitors = async () => {
  try {
    // Try server API first for multi-device sync
    const res = await fetch('/api/live-visitors.php?action=list');
    if (res.ok) {
      const data = await res.json();
      if (data.status === 'success' && Array.isArray(data.visitors) && data.visitors.length > 0) {
        return data.visitors;
      }
    }
  } catch (e) {}

  // Fallback to localStorage
  try {
    const saved = localStorage.getItem('satala_realtime_visitors');
    if (saved) {
      const parsed = JSON.parse(saved);
      if (Array.isArray(parsed)) {
        const fiveMinsAgo = Date.now() - 5 * 60 * 1000;
        return parsed.filter(v => v.lastActive > fiveMinsAgo);
      }
    }
  } catch (e) {}

  return [];
};
